import type { ExperimentConfig } from '../@types'

// UI-paywall-часть эксперимента удалена (DEV-34602): группа B видит базовый пейвол своей
// воронки, а Move-юзеры помечаются на бэке полем application в create-subscription
// (см. src/modules/WebBilling/composables/useSubscriptionApplication.js).
// Текущая paywall-часть меняет только конфиг: помечает вариант B Move-юзером в Braze
// (config.brazeAttributes → is_moves_user, PR #567).
const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () => import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves'),
				},
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () => import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves'),
				},
			},
		},
		'activity-female-military-calisthenics': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-military-calisthenics&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					// База upsell-military-calisthenics-f — чистый bundle-activity с гео-ветвлением
					// цен (US/RoW/остальные), поэтому override __activity_m, несмотря на «_m» в имени.
					'upsell-military-calisthenics-f': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'),
				},
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'),
				},
			},
		},
		'activity-male-chair-tai-chi-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'),
				},
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'),
				},
			},
		},
		'activity-male-military-calisthenics': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-military-calisthenics&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					// База upsell-military-calisthenics-m — безусловная US-лесенка (45%/60%),
					// как у tai-chi-walking-f, поэтому плоский override.
					'upsell-military-calisthenics-m': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves'),
				},
			},
		},
	},
]

export default config
